import { RootState } from "@/redux/store";

export const accessTokenSelector = (state: RootState) => state.auth.accessToken;
export const loggedOutSelector = (state: RootState) => state.auth.loggedOut;
